import { GetOTPButton } from '@sravni/react-silent-authentication-form';
import cn from 'classnames';
import React from 'react';

import type { CustomAuthInlineFormProps } from 'shared/ui/CustomAuthInlineForm';

import styles from './AuthInlineForm.module.scss';

type Props = CustomAuthInlineFormProps['getOTPButtonProps'];

export const OTPButton: FC<Props> = (props) => {
  const { onClick, loading: isLoading, className, ...otherProps } = props || {};

  return (
    <GetOTPButton
      {...otherProps}
      onClick={onClick}
      loading={isLoading}
      size={52}
      className={cn(styles.getOTPButton, className)}
    />
  );
};
